(function () {
    function setCookie(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        if (keyValue) {
            return keyValue ? keyValue[2] : null;
        }
    }


    let cookieTimer = getCookie("timer_advertorial");
    // console.log("cookieTimer: advertorial", cookieTimer);

    let timer = document.querySelector('.article[timer-section] .timer__clock-face.unactive');
    timer.classList.remove("unactive");
    let daysSpan = timer.querySelector('.days');
    let hoursSpan = timer.querySelector('.hours');
    let minutesSpan = timer.querySelector('.minutes');
    let secondsSpan = timer.querySelector('.seconds');
    let checkoutButton = document.querySelector('#timer .timer__checkout');
    let sectionTimer;
    if (timer.closest('.section-timer')) {
        sectionTimer = timer.closest('.section-timer');
    }else if (timer.closest('.section-timer-sidebar')){
        sectionTimer = timer.closest('.section-timer-sidebar');
    };
    let sectionTimerHeidht = getComputedStyle(sectionTimer).height;
    sectionTimer.style.height = "0px";

    let longCookie = +timer.getAttribute("long-cookie");
    let endtimePlaceDays = 0;
    let endtimePlaceHours = 0;
    let endtimePlaceMinutes = 0;
    if (timer.getAttribute("data-timer-days")) {
        endtimePlaceDays = +timer.getAttribute("data-timer-days");
    }
    if (timer.getAttribute("data-timer-hours")) {
        endtimePlaceHours = +timer.getAttribute("data-timer-hours");
    }
    if (timer.getAttribute("data-timer-minutes")) {
        endtimePlaceMinutes = +timer.getAttribute("data-timer-minutes");
    }
    let endtimeNow = Date.parse(new Date()) + endtimePlaceDays + endtimePlaceHours + endtimePlaceMinutes;
    let endtime = new Date(endtimeNow);

    let timeinterval;
    if (cookieTimer == undefined ) {
        timeinterval = setInterval(updateClock,1000);
        updateClock();
        setCookie("timer_advertorial", endtimeNow, longCookie)
        setTimeout(() => {
            sectionTimer.style.opacity = 1;
            sectionTimer.style.height = sectionTimerHeidht;
        }, 0);
    } else if (+cookieTimer) {
        if ((cookieTimer - Date.parse(new Date()) <= 0)) {
            setCookie("timer_advertorial", 0, longCookie);
            checkoutButton.click();
        } else {
            endtime = new Date(+cookieTimer);
            timeinterval = setInterval(updateClock,1000);
            updateClock();
            setTimeout(() => {
                sectionTimer.style.opacity = 1;
                sectionTimer.style.height = sectionTimerHeidht;
            }, 0);
        }

    }

    function updateClock(){
        let t = getTimeRemaining(endtime);

        if (daysSpan) {
            update(daysSpan, t.days);
        }
        if (hoursSpan) {
            update(hoursSpan, t.hours);
        }
        if (minutesSpan) {
            update(minutesSpan, t.minutes);
        }
        if (secondsSpan) {
            update(secondsSpan, t.seconds);
        }
        if(t.total<=0){
            clearInterval(timeinterval);
            setCookie("timer_advertorial", 0, longCookie);
            // checkoutButton.click();
        }
    }

    function update(place, time) {
        if (time < 10 ) {
            time = '0' + time;
        }
        let top = place.querySelector('.card__top'),
            bottom = place.querySelector('.card__bottom'),
            back = place.querySelector('.card__back'),
            backBottom = place.querySelector('.card__back .card__bottom');

        setTimeout(() => {
            back.setAttribute('data-value', time);
            bottom.setAttribute('data-value', time);
        }, 350);

        backBottom.setAttribute('data-value', time);
        if (time == top.innerText) {
            return;
        }
        top.innerText = time;

        place.classList.remove('flip');
        void place.offsetWidth;
        place.classList.add('flip');

    }

    function getTimeRemaining(endtime){
        let t = Date.parse(endtime) - Date.parse(new Date());
        let seconds = Math.floor( (t/1000) % 60 );
        let minutes = Math.floor( (t/1000/60) % 60 );
        let hours = Math.floor( (t/(1000*60*60)) % 24 );
        let days = Math.floor( t/(1000*60*60*24) );
        return {
        'total': t,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
        };
    }


})();




